import { render } from "./pr-form.vue?vue&type=template&id=ed1040a0&scoped=true"
import script from "./pr-form.vue?vue&type=script&lang=js"
export * from "./pr-form.vue?vue&type=script&lang=js"

import "./pr-form.vue?vue&type=style&index=0&id=ed1040a0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed1040a0"]])

export default __exports__